import React, { memo, useRef } from 'react';
import { M32ProductCarouselModule as M32ProductCarouselProps } from '~/lib/data-contract';
import ProductCarousel from './components/product-carousel/product-carousel.component';
import { useInView } from '~/shared/hooks/useInView/useInView';
import ProductCarouselSkeleton from './components/product-carousel-skeleton/product-carousel-skeleton.component';
import { config } from './constants';
import { useTrendingItems } from './hooks';
import { Container } from '../container/container.component';

const M32ProductCarousel = memo(
    ({ maxNumberItems, threshold, facetName, facetValue, ...rest }: M32ProductCarouselProps) => {
        const ref = useRef(null);
        const isInView = useInView(ref, config.intersectionObserverOptions);
        const { hits, isLoading } = useTrendingItems(
            {
                maxRecommendations: maxNumberItems ?? config.maxNumberItemsDefault,
                ...(threshold && { threshold }),
                ...(facetName && { facetName }),
                ...(facetValue && { facetValue }),
            },
            isInView
        );

        return (
            <div ref={ref}>
                <Container {...rest}>
                    {isInView ? (
                        <ProductCarousel hits={hits} isLoading={isLoading} />
                    ) : (
                        <ProductCarouselSkeleton />
                    )}
                </Container>
            </div>
        );
    }
);

export default M32ProductCarousel;
